import { purry } from './purry';
export function chunk() {
    return purry(_chunk, arguments);
}
function _chunk(array, size) {
    var ret = Array.from({
        length: Math.ceil(array.length / size),
    });
    for (var index = 0; index < ret.length; index += 1) {
        ret[index] = array.slice(index * size, (index + 1) * size);
    }
    return ret;
}
